import { LOREM_IPSUM } from '../constants/lorem-ipsum'

const WIDTH = 330

export const StickyHTML = (widgetId: string, date: string, token: string, scriptCode: string): string => `
  <!DOCTYPE html>
  <html>
    <head>
      <meta name="viewport" content="width=360, initial-scale=1.0, user-scalable=no, viewport-fit=cover">
      <style>
      html, body {
          margin: 0;
          padding: 0;
          height: auto;
          min-height: 100%;
          width: ${WIDTH}px;
          max-width: ${WIDTH}px;
          overflow-x: hidden;
          overflow-y: auto;
          background-color: #fff;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          line-height: 1.6;
        }
        * {
          box-sizing: border-box;
        }
        .header {
          margin-top: 30px;
          margin-left: 10px;
          border-bottom: 1px solid #e5e5e5;
          margin-bottom: 0;
        }
        .header h1 {
          font-size: 24px;
          font-weight: 700;
          color: #d63384;
          margin-top: 0px;
          margin-bottom: 8px;
        }
        .header .subtitle {
          font-size: 12px;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .content {
          box-sizing: border-box;
          width: 100%;
        }
        .article-title {
          font-size: 20px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 12px 0;
          line-height: 1.3;
          margin: 10px;
        }
        .article-meta {
          font-size: 12px;
          color: #666;
          margin-bottom: 16px;
          border-bottom: 1px solid #f0f0f0;
          margin-left: 10px;
          margin-right: 10px;
        }
        .article-content {
          margin-left: 10px;
          margin-right: 10px;
        }
        .image-content {
          width: 100%;
          max-width: 300px;
          height: auto;
          display: block;
          margin-left: 20px;
        }
        .content p {
          line-height: 1.6;
          color: #333;
          text-align: justify;
        }
        .highlight {
          background: linear-gradient(120deg, #eddca3 0%, #fff3cd 100%);
          background-repeat: no-repeat;
          background-size: 100% 0.2em;
          background-position: 0 88%;
        }
        drupi-sticky {
          pointer-events: none !important;
          width: 100%;
          max-width: 100%;
        }
      </style>
      <script src=${scriptCode}></script>
    </head>
    <body>

      <div class="header">
        <h1>Noticias en Argentina</h1>
        <div class="subtitle">Últimas noticias • ${new Date().toLocaleDateString('es-ES')}</div>
      </div>
      <div class="content">
        <h2 class="article-title">Avances en Tecnología Transforman el Sector Empresarial</h2>
        <div class="article-meta">Por Redacción • Hace 2 horas • Economía</div>
        <p class="article-content">Las empresas de todo el mundo están experimentando una <span class="highlight">transformación digital</span> sin precedentes, impulsada por los avances en inteligencia artificial y automatización.</p>
        <img class="image-content" src="http://i.pinimg.com/736x/c6/ca/cd/c6cacd7a728423aede3eec4a9a04eb6f.jpg" alt="Logo" />
        ${LOREM_IPSUM.split('\n')
          .map(paragraph => `<p style="margin: 0 10px;">${paragraph}</p>`)
          .join('')}
      </div>
        <drupi-sticky
          widgetId=${widgetId}
          date="${date}"
          disable-cache="${token}"
        ></drupi-sticky>
    </body>
  </html>
`
